import styled from 'styled-components';

export const Container = styled.div`
  .strategic-questions-group + .strategic-questions-group {
    margin-top: 16px;
  }

  .strategic-questions-group-title {
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.2;
    letter-spacing: -0.32px;
    color: #343a40;
    margin: 0 0 16px;
  }

  .strategic-question {
    max-width: 672px;
    border: 1px solid #adb5bd;
    border-radius: 4px;
    background: #ffffff;

    & + .strategic-question {
      margin-top: 16px;
    }
  }

  .strategic-question-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px;
    border: 0;
    background: transparent;
    text-align: left;
    color: #343a40;
    cursor: pointer;

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.$primary_green};
      outline-offset: 2px;
    }

    svg {
      flex-shrink: 0;
    }
  }

  .strategic-question-title {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    line-height: 1.2;
    letter-spacing: -0.32px;
  }

  .strategic-question-body {
    padding: 0 12px 12px;
  }

  .strategic-question-label {
    font-size: 13px;
    line-height: 1.3;
    color: #6c757d;
    margin-bottom: 7px;
  }

  .strategic-question-answer,
  .strategic-question-pending {
    font-size: 16px;
    line-height: 1.2;
    color: #343a40;
    white-space: pre-line;
  }

  .strategic-question-pending,
  .strategic-questions-message {
    color: #6c757d;
  }
`;
